import { Link } from "react-router-dom";
import { useLang, localize } from "@/lib/i18n";

export const LangSwitcher = ({ mobile = false }) => {
  const { lang, basePath } = useLang();
  const size = mobile ? "text-base" : "text-xs";
  return (
    <div
      className={`flex items-center gap-2 font-mono font-medium tracking-[0.12em] ${size}`}
      data-testid={mobile ? "mobile-lang-switcher" : "lang-switcher"}
    >
      {["fr", "en"].map((l, i) => (
        <span key={l} className="flex items-center gap-2">
          {i > 0 && <span className="text-line">|</span>}
          <Link
            to={localize(basePath, l)}
            aria-current={lang === l ? "true" : undefined}
            hrefLang={l}
            data-testid={`${mobile ? "mobile-" : ""}lang-link-${l}`}
            className={`transition-colors duration-300 ${
              lang === l ? "text-brand font-bold" : "text-muted hover:text-navy"
            }`}
          >
            {l.toUpperCase()}
          </Link>
        </span>
      ))}
    </div>
  );
};
